<template>
  <div id="main-box">
    <div class="page-content" :class="{bottom:list.length > 0}">
      <div class="table-box layui-body" style="left:0;">
        <div class="xblock layui-form">
          <div class="layui-input-inline xblock-row">
            <button class="layui-btn" v-on:click="AddRecord('添加快递')"><i class="fa fa-plus"></i> 添加快递</button>
          </div>
          <div class="layui-input-inline xblock-row">
            <input type="text" name="username" placeholder="快递单号查询" v-on:keydown.13="GetList(true)" v-model="shipment_number"
              autocomplete="off" class="layui-input" />
          </div>
          <div class="layui-input-inline country_select xblock-row">
            <select name="status" lay-verify="required" lay-filter="status_selection">
              <option value="0">全部</option>
              <option :value="item.id" v-text="item.name" v-for="(item,index) in status" v-bind:key="index"></option>
            </select>
          </div>
          <div class="layui-input-inline xblock-row">
            <button class="layui-btn" style="height: 35px;" v-on:click="GetList(true)"><i
                class="fa fa-search"></i></button>
          </div>
          <span class="x-right xblock-row" v-text="'　共有数据：'+count+ '条'"></span>
          <div class="clear-both"></div>
        </div>

        <div class="table-box-list">
          <table class="layui-table layui-table-margin">
            <thead>
              <tr>
                <th>仓库</th>
                <th>用户ID</th>
                <th>快递单号</th>
                <th>状态</th>
                <th>内容</th>
                <th>时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody v-viewer>
              <tr class="order_box" v-for="(item,index) in list" v-bind:key="index">
                <td>
                  <div style="width: 45px;">
                    <i v-for="val in warehouseList" v-if="item.warehouse == val.id" v-text="val.name"></i>
                  </div>
                </td>
                <td v-text="item.uid"></td>
                <td v-text="item.shipment_number"></td>
                <td>
                  <div style="width: 55px;">
                    <i v-if="item.is_handle == 0" class="status-box status-box-green">未检测</i>
                    <i v-else class="status-box status-box-red">已检测</i>
                  </div>
                </td>
                <td>
                  <div class="imglist">
                    <img v-for="val in item.verify_photo" :src="val">
                  </div>
                </td>
                <td v-text="item.created_at"></td>
                <td class="btn-arr" style="width: 170px;">
                  <button class="layui-btn" v-on:click="AddRecord('修改快递',item)">编辑</button>
                  <button class="layui-btn layui-btn-danger" v-on:click="ConfirmHint(1,item)">删除</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- transition -->
        <K-Transition :isLoding="isLoding" v-if="isLoding || list.length < 1" style="margin-top: 16px;"></K-Transition>

      </div>

    </div>

    <!-- 分页 -->
    <div class="page-box"><div id="pagebox" class="pagebox"></div></div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    <!-- 确认框 -->
    <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>
  </div>
</template>

<script>
  var self, form, layer, laypage, modalbox;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  import Confirm from '@/components/common/Confirm.vue'
  export default {
    name: 'PackageExamine',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
      'K-Confirm': Confirm,
    },
    data() {
      return {
        id: null,
        shipment_number:null,
        isLoding: false,
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        Confirm: {
          state: false,
          txt: null
        },
        page: 1,
        count: 0,
        total: 0,
        page_num: 20,
        status_id: 0,
        list: [],
        itemid:null,
        status: [{
          id: 1,
          name: "未检测"
        }, {
          id: 2,
          name: "已检测"
        }],
        warehouseList:warehouseList
      }
    },
    mounted() {
      self = this;
      self.SetNavActive("货代",self.$route.name);

      layui.use(['form', 'layer', 'laypage'], function() {
        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;

        //类型
        form.on('select(status_selection)', function(data) {
          self.status_id = data.value;
          self.GetList();
        });

        //退货方式
        form.on('radio(returnType)', function(data) {
          if(data.value == 0){
            $(".pickupCode").hide();
            $(".returnInfo").show();
          }else{
            $(".pickupCode").show();
            $(".returnInfo").hide();
          }
        });

        form.render('select');

        self.GetList()
      });
    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      ConfirmHint(te, item) {
        self.Confirm.style = te;
        self.Confirm.state = true;
        self.Confirm.txt = "是否确认删除？"
        self.id = item.id;
      },
      ConfirmBackFun(data) {
        self.Confirm.state = data.state;
        if (data.state) {
          self.loading = true;
          self.Confirm.state = false;
          let param = new URLSearchParams()
          param.append('id', self.id)
          self.loading = true;
          axios({
            method: 'post',
            url: self.GetServerUrl() + "/del_check_shipment/",
            data: param,
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            }
          }).then(function(response) {

            //返回数据处理
            self.ReturnFuntion(self, response, function(datas) {
              layer.msg("删除成功！");
              self.GetList();
            }, false, true);

          }).catch(function(error) {
            self.loading = false;
            console.log(error);
          })
        }
      },
      GetList(state) {
        if(state){
          self.page = 1;
          self.list = [];
        }
        self.isLoding = true;
        let param = new URLSearchParams()
        param.append('num', self.page_num)

        if(self.status_id > 0){
          let state = self.status_id - 1;
          param.append('is_handle', state)
        }
        if(self.shipment_number){
          param.append('shipment_number', self.shipment_number)
        }

        axios({
          method: 'post',
          url: self.GetServerUrl() + "/check_shipment_list/?page=" + self.page,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.isLoding = false;

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            if (datas.page) {
              var list = datas.list;
              for (let item in list) {
                if (list[item].verify_photo) {
                  list[item].verify_photo = JSON.parse(list[item].verify_photo);
                }
              }
              self.list = list;
              self.total = datas.total;
              self.count = datas.page.count;
              self.ShowPage(self, laypage, "GetList"); //分页
              $('.pagebox').show();
            } else {
              self.list = [];
              self.count = 0; //页数
              $('.pagebox').hide();
            }
          });

        }).catch(function(error) {
          self.isLoding = false;
          console.log(error);
        })
      },
      AddRecord(title,item) {
        self.id = null;
        var w;
        if (w == null || w == '') {
          w = $(window).width() - 260;
          if (w > 500) {
            w = 500;
          }
        };
        modalbox = layer.open({
          type: 1,
          offset: '100px',
          title: '快递拍照（0.5元一个快递）',
          area: [w + 'px', '330px'],
          fixed: false, //不固定
          btn: ['确定'],
          content: AddCourier,
          success: function() {
            if(item){
              self.id = item.id;
              $("#LogList").val(item.shipment_number);
            }
            if(localStorage.getItem("ExShopee_id") == 1){
              $(".uidbox").show();
            }
            form.render();
          },
          yes: function(index, layero) {
            self.release();
          }
        });
      },
      release () {
        var LogList = $("#LogList").val();
        var warehouse = $("#warehouse").val();
        var uid = $("#uid").val();
        if(!LogList){
          layer.close(modalbox);
          return;
        }
        LogList = LogList.split(/[\n,]/g);
        var datas = {shipment_numbers: JSON.stringify(LogList)}
        if(self.id){
          datas.id = self.id;
        }
        if(uid){
          datas.uid = uid;
        }
        if(warehouse){
          datas.warehouse = warehouse;
        }
        self.loading = true;
        $.ajax({
          url: self.GetServerUrl() + "/check_shipment_store/",
          type: 'post',
          data: datas,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          },
          success: function(res) {
            layer.close(modalbox);
            self.loading = false;
            layer.msg("操作成功！");
            self.GetList();
          },
          error: function(error) {
            self.loading = false;
            layer.msg(error);
          }
        })


      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }
  .country_select {
    width: 150px;
  }
  .imglist img{
    margin-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/logistics/PackageExamine.vue